import { JwtTokenFn } from "@me8eon/authentication";
import ApiCall from "./ApiCall";

async function authHeaders(token?: JwtTokenFn): Promise<Record<string, string>> {
    if (!token) return {};
    const jwt = await token();
    return jwt ? { Authorization: `Bearer ${jwt}` } : {};
}

export const getUserBookingApi = async(
    payload: any,
    token?: JwtTokenFn
): Promise<any> => {
    console.log("Get User Booking", payload);
    return await ApiCall(
        "api/gingco/GetUserBookings",
        "post",
        payload,
        await authHeaders(token)
    );
};

export const getBookingContainerTemplateApi = async(
    payload: any,
    token?: JwtTokenFn
): Promise<any> => {
    console.log("Get Booking Container", payload);
    return await ApiCall(
        "api/gingco/GetBookingContainerTemplates",
        "post",
        payload,
        await authHeaders(token)
    );
};

export const updateBookingApi = async(
    payload: any,
    token?: JwtTokenFn
): Promise<any> => {
    console.log("Update Booking", payload);
    return await ApiCall(
        "api/gingco/updateBookings",
        "post",
        payload,
        await authHeaders(token)
    );
};

export const cancelBookingApi = async(
    payload: any,
    token?: JwtTokenFn
): Promise<any> => {
    console.log("Cancel Booking", payload);
    return await ApiCall(
        "api/gingco/CancelBookings",
        "post",
        payload,
        await authHeaders(token)
    );
};

export const getTimeLinesApi = async(
    payload: any,
    token?: JwtTokenFn
): Promise<any> => {
    console.log("Get TimeLines", payload);
    return await ApiCall(
        "api/gingco/GetTimeLines",
        "post",
        payload,
        await authHeaders(token)
    );
};

export const saveBookingsApi = async(
    payload: any,
    token?: JwtTokenFn
): Promise<any> => {
    console.log("Save Booking", payload);
    return await ApiCall(
        "api/gingco/SaveBookings",
        "post",
        payload,
        await authHeaders(token)
    );
};

export const getBookableLocationsApi = async(
    payload: any,
    token?: JwtTokenFn
): Promise<any> => {
    return await ApiCall(
        "api/gingco/GetBookableLocations",
        "post",
        payload,
        await authHeaders(token)
    );
};
